<template>
  <div>
    <page-title>All Users</page-title>
    <div
      class="has-background-white has-padding-left-30 has-padding-right-30 has-padding-bottom-15 has-padding-top-15"
    >
      <h2
        class="is-size-4 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black has-margin-bottom-10"
      >All Users</h2>
      <all-users-table
        :userData="allUsers"
        :isBackendPaginated="true"
        :currentPage="currentPage"
        :total="total"
        :onPageChange="onPageChange"
        canUpdate
        canDelete
      ></all-users-table>
      <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
    </div>
  </div>
</template>

<script>
import AllUsersTable from "../components/UsersTable";
import { ADMIN_MUTATION_TYPES } from "@/store/mutation-types";
import AdminUsersQuery from "../api/graphql/queries/AdminUsersQuery";
import { createNamespacedHelpers } from "vuex";
const { mapGetters, mapMutations } = createNamespacedHelpers("admin");

export default {
  name: "admin-all-users",
  components: { AllUsersTable },
  data() {
    return {
      isLoading: false,
      currentPage: 1,
      total: 0
    };
  },
  mounted() {
    /**
     * Load the NIMASA Admin users from the api on mount
     */
    if (this.isNimasaAdmin) {
      this.loadUsersNimasaAgentFromAPI(this.currentPage);
      this.loadUsersNimasaManagerFromAPI(this.currentPage);
    }

    /**
     * Load the Hudsontrident Admin users from the api on mount
     */

    if (this.isHudsontridentUser) {
      this.loadUsersForNimasaAdminFromAPI(this.currentPage);
      this.loadUsersPortFromAPI(this.currentPage);
    }
  },
  computed: {
    ...mapGetters({
      isHudsontridentUser: "isHudsontridentUser",
      isNimasaAdmin: "isNimasaAdmin",
      allUsersForNimasaAdmin: "getAllUsersForNimasaAdminUser",
      allUsersForPort: "getAllUsersForPort",
      allUsersForNimasaManager: "getAllUsersForNimasaManager",
      allUsersForNimasaAgent: "getAllUsersForNimasaAgent"
    }),
    allUsers: function() {
      if (this.isNimasaAdmin) {
        return this.allUsersForNimasaManager.concat(
          this.allUsersForNimasaAgent
        );
      }
      if (this.isHudsontridentUser) {
        return this.allUsersForNimasaAdmin.concat(this.allUsersForPort);
      }
    }
  },
  methods: {
    ...mapMutations({
      saveNimasaAdminUsers: ADMIN_MUTATION_TYPES.SAVE_NIMASA_ADMIN_USERS,
      savePortUsers: ADMIN_MUTATION_TYPES.SAVE_PORT_USERS,
      saveNimasaUsers: ADMIN_MUTATION_TYPES.SAVE_NIMASA_USERS,
      saveNimasaManagerUsers: ADMIN_MUTATION_TYPES.SAVE_NIMASA_MANAGER_USERS
    }),

    loadUsersForNimasaAdminFromAPI: function(page) {
      this.isLoading = true;

      this.$apollo
        .query({
          query: AdminUsersQuery.NimasaAdminUsers,
          variables: {
            page
          }
        })
        .then(response => {
          const users = response.data.GetNimasaAdminUsers.data;
          this.saveNimasaAdminUsers(users);

          const {
            total,
            currentPage
          } = response.data.GetNimasaAdminUsers.paginatorInfo;
          this.total = total;
          this.currentPage = currentPage;

          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "Users loaded successfully.",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "Failed to load users",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    loadUsersPortFromAPI: function(page) {
      this.isLoading = true;

      this.$apollo
        .query({
          query: AdminUsersQuery.PortUsers,
          variables: {
            page
          }
        })
        .then(response => {
          const users = response.data.GetAllPortUsers.data;
          this.savePortUsers(users);

          const {
            total,
            currentPage
          } = response.data.GetAllPortUsers.paginatorInfo;
          this.total = total;
          this.currentPage = currentPage;

          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "Users loaded successfully.",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "Failed to load users",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    loadUsersNimasaAgentFromAPI: function(page) {
      this.isLoading = true;

      this.$apollo
        .query({
          query: AdminUsersQuery.NimasaUsers,
          variables: {
            page
          }
        })
        .then(response => {
          const users = response.data.GetNimasaUsers.data;
          this.saveNimasaUsers(users);

          const {
            total,
            currentPage
          } = response.data.GetNimasaUsers.paginatorInfo;
          this.total = total;
          this.currentPage = currentPage;

          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "Users loaded successfully.",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "Failed to load users",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    loadUsersNimasaManagerFromAPI: function(page) {
      this.isLoading = true;

      this.$apollo
        .query({
          query: AdminUsersQuery.NimasaManagerUsers,
          variables: {
            page
          }
        })
        .then(response => {
          const users = response.data.GetNimasaManagers.data;
          this.saveNimasaManagerUsers(users);

          const {
            total,
            currentPage
          } = response.data.GetNimasaManagers.paginatorInfo;
          this.total = total;
          this.currentPage = currentPage;

          this.$toast.open({
            duration: 3000,
            position: "is-top-right",
            message: "Users loaded successfully.",
            type: "is-success"
          });
        })
        .catch(error => {
          this.$toast.open({
            duration: 4000,
            position: "is-top-right",
            message: "Failed to load users",
            type: "is-danger"
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onPageChange(page) {
      this.currentPage = page;
      if (this.isNimasaAdmin) {
        this.loadUsersNimasaAgentFromAPI(this.currentPage);
        this.loadUsersNimasaManagerFromAPI(this.currentPage);
      }

      if (this.isHudsontridentUser) {
        this.loadUsersForNimasaAdminFromAPI(this.currentPage);
        this.loadUsersPortFromAPI(this.currentPage);
      }
    }
  }
};
</script>
